import Button from '@rio-cloud/rio-uikit/Button';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export type SummaryStepSectionProps = {
    title: string;
    innerClassName?: string;
    className?: string;
    goToFunction: () => void;
    children: ReactNode;
};

type EditButtonProps = {
    onClickFunction: () => void;
};
const EditButton = ({ onClickFunction }: EditButtonProps) => (
    <Button onClick={onClickFunction}>
        <span className='rioglyph rioglyph-pencil text-size-20 margin-right-10' />
        <FormattedMessage id='general.button.edit' />
    </Button>
);

const SummaryStepSection = (props: SummaryStepSectionProps) => {
    const { title, goToFunction, innerClassName = 'flex-basis-80pct', className = '', children } = props;

    return (
        <div className={`margin-bottom-15 rounded bg-white padding-25 ${className}`}>
            <div className='display-flex flex-row justify-content-between'>
                <div className='text-bold text-size-18 padding-bottom-5'>{title}</div>
                <EditButton onClickFunction={goToFunction} />
            </div>
            <div className='display-flex flex-row gap-20'>
                <div className={`${innerClassName} text-size-14`}>{children}</div>
            </div>
        </div>
    );
};

export default SummaryStepSection;
